import { SelectionWrapper } from "widgets/configurator/door-options-controls/SelectionWrapper";
import { HandleList } from "./HandleList";

const HandleOptionControls = () => {
  return (
    <SelectionWrapper className="gg-pt-4">
      <HandleList />
    </SelectionWrapper>
  );
};
export default HandleOptionControls;
